<a class="nav-link nav-item px-0"
   [routerLinkActive]="item?.children ? '' : 'active'"
   [class.dropdown]="item?.children"
   [ngClass]="item.styleClass"
   [routerLink]="item?.children ? [] : [item.routerUrl]"
   [class.active-item]="isActiveItem$ | async"
   [routerLinkActiveOptions]="{exact: item.exact !== undefined ? item.exact : false}">
    <div class="nav-item-overlay">
    </div>

    <div class="nav-item-div">
        <ng-container [ngTemplateOutlet]="iconTemplate || defaultIcon" [ngTemplateOutletContext]="{$implicit: item}">
        </ng-container>

        <ng-container [ngTemplateOutlet]="contentTemplate || default" [ngTemplateOutletContext]="{$implicit: item}">
        </ng-container>
    </div>

    <div class="dropdown-menu" *ngIf="item?.children">
        <a class="dropdown-item"
           *ngFor="let child of item.children"
           routerLinkActive="active"
           [routerLink]="[child.routerUrl]"
           [routerLinkActiveOptions]="{exact: child.exact !== undefined ? child.exact : false}">
            <span class="nav-item-title">{{ child.title }}</span>

            <i class="fa fa-chevron-right"></i>
        </a>
    </div>
</a>

<ng-template #default let-item>
    <span class="nav-item-title">
        {{ item.title }}
    </span>
</ng-template>

<ng-template #defaultIcon let-item>
    <cap-notification-badge class="d-block" [showBadge]="!!item.notificationBadgeOptions"
                            [options]="item.notificationBadgeOptions">
        <i class="icon-menu fa-fw {{ item.icon }}"></i>
    </cap-notification-badge>
</ng-template>
